import { InternalScheduleActionDialogProps } from '../types';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { InternalScheduleActionDialogActions } from '../actions';
import { ActionSheet } from '@components/scheduling/actionSheet';

export const SpecialtyOverrideDialog = ({
  open,
  setOpen,
  onCancel,
  onConfirm,
  disabled,
  sheet,
}: InternalScheduleActionDialogProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'specialtyOverride' });

  const actions = (
    <InternalScheduleActionDialogActions
      type="specialty"
      onCancel={() => {
        setOpen(false);
        onCancel();
      }}
      onConfirm={() => {
        setOpen(false);
        onConfirm();
      }}
      disabled={disabled}
    />
  );

  if (sheet)
    return (
      <ActionSheet
        open={open}
        onDismiss={() => {
          setOpen(false);
          onCancel();
        }}
        title={t('title')}
        description={t('description')}
        actions={actions}
      />
    );

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('description')}</AlertDialogDescription>
        </AlertDialogHeader>
        {actions}
      </AlertDialogContent>
    </AlertDialog>
  );
};
